import React from '@wordpress/element';
import { render } from '@wordpress/element';
import PingVidWidget from './components/PingVidWidget.js';

/**
 * Main initialization function for PingVid
 * Finds video data in the DOM and mounts the widget
 */
function initPingVid() {
	if (window.__pingvidInitialized) {
		return;
	}
	window.__pingvidInitialized = true;

	const settings = window.devnet_pingvid_script_data?.settings || {};

	let videoElement = document.querySelector('[data-pingvid-video]');
	if (!videoElement) {
		videoElement = document.querySelector('#pingvid-iframe');
	}
	if (!videoElement) {
		return;
	}

	const videoId =
		videoElement.dataset.videoId ||
		videoElement.getAttribute('data-video-id');

	const platform =
		videoElement.dataset.platform ||
		videoElement.getAttribute('data-platform') ||
		'youtube';

	if (platform !== 'youtube' || !videoId) {
		return;
	}

	const aspectRatio =
		videoElement.dataset.aspectRatio ||
		videoElement.getAttribute('data-aspect-ratio') ||
		'9:16';

	// Normalize display
	if (!settings.display || typeof settings.display !== 'object') {
		settings.display = {};
	}
	settings.display.aspect_ratio = aspectRatio;

	const existingWrapper = document.querySelector('#pingvid-wrapper');
	if (existingWrapper) {
		existingWrapper.remove();
	}

	let appContainer = document.getElementById('pingvid-react-app');
	if (!appContainer) {
		appContainer = document.createElement('div');
		appContainer.id = 'pingvid-react-app';
		document.body.appendChild(appContainer);
	}

	render(
		<PingVidWidget settings={settings} videoId={videoId} />,
		appContainer
	);
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initPingVid);
} else {
	setTimeout(initPingVid, 100);
}

export default initPingVid;
